/* eslint-disable no-return-assign */
import { sumObjVals } from "Helpers/util";
import { apiUpdateItems } from "Root/api/apiCheckout";
const makeCountObj = (flavors) => flavors.reduce((map, obj) => {
    const temp = { ...map };
    temp[obj.short_name] = obj.count || 0;
    return temp;
}, {});
const updateFlavors = async ({ cart, proteinFlavors, error_message, preworkoutFlavors, hydrationFlavors, greensFlavors, setUserCart, addonAttributes, flavorLimits, setUpdatingFlavors, }) => {
    if (cart.hydration === 0 &&
        cart.protein === 0 &&
        cart.preworkout === 0 &&
        cart.creatine === 0 &&
        cart.collagen === 0 &&
        cart.fiber === 0 &&
        cart.greens === 0) {
        error_message("*Please select at least 1 subscription item");
        return;
    }
    const proteinFlavorCountObj = makeCountObj(proteinFlavors);
    const proteinFlavorCount = sumObjVals(proteinFlavorCountObj);
    if (proteinFlavorCount < flavorLimits.protein && cart.protein > 0) {
        error_message("*Please make flavor selections before proceeding to checkout.");
        return false;
    }
    const preworkoutFlavorCountObj = makeCountObj(preworkoutFlavors);
    const preworkoutFlavorCount = sumObjVals(preworkoutFlavorCountObj);
    if (preworkoutFlavorCount < flavorLimits.preworkout && cart.preworkout > 0) {
        error_message("*Please make flavor selections before proceeding to checkout.");
        return false;
    }
    const hydrationFlavorCountObj = makeCountObj(hydrationFlavors);
    const hydrationFlavorCount = sumObjVals(hydrationFlavorCountObj);
    if (hydrationFlavorCount < flavorLimits.hydration && cart.hydration > 0) {
        error_message("*Please make flavor selections before proceeding to checkout.");
        return false;
    }
    const greensFlavorCount = makeCountObj(greensFlavors);
    const greensFlavorCountTotal = sumObjVals(greensFlavorCount);
    if (greensFlavorCountTotal < flavorLimits.greens && cart.greens > 0) {
        error_message("*Please make flavor selections before proceeding to checkout.");
        return false;
    }
    const flavor_data = {};
    if (cart.protein > 0) {
        flavor_data.protein = proteinFlavorCountObj;
    }
    if (cart.hydration > 0) {
        flavor_data.hydration = hydrationFlavorCountObj;
    }
    if (cart.preworkout > 0) {
        flavor_data.preworkout = preworkoutFlavorCountObj;
    }
    if (cart.greens > 0) {
        flavor_data.greens = greensFlavorCount;
    }
    const postdata = {
        flavordata: flavor_data,
        attributes: addonAttributes,
    };
    const updateItems = async () => {
        try {
            const data = await apiUpdateItems(postdata);
            setUserCart(data.userCart);
            setUpdatingFlavors(false);
            return data;
        }
        catch (err) {
            setUpdatingFlavors(false);
        }
    };
    const data = await updateItems();
    return data;
};
export default updateFlavors;
